export default __webpack_public_path__ + "static/media/gallery_12.7c57ee98.jpg";